import { allPredefinedFilters, fieldType } from 'app/area/search-filters/constants';
import { 
  CustomFilterType, Filter, FilterType, PredefinedFilter, PredefinedFilterType 
} from 'app/area/search-filters/filters/types';
import { filterId, UserMembersTranslation } from 'app/area/subscriber-groups/user-members/constants';

export const predefinedFilters = (translation: UserMembersTranslation): PredefinedFilter => ({
  type: PredefinedFilterType.code,
    values: [
      { value: allPredefinedFilters.hideDisabledUsers, description: translation.hide_inactive_users }
    ]
});

export const userMembersFilters = (
  translation: UserMembersTranslation
): Filter[] => [
  {
      id: filterId.name,
      label: translation.filter_name,
      fields: [
        {
          fieldTypeId: fieldType.root,
          type: CustomFilterType.text,
          includeInSummary: true
        }
      ],
      type: FilterType.TEXT
    },
    {
        id: filterId.email,
        label: translation.filter_email,
        fields: [
          {
            fieldTypeId: fieldType.textSpecified,
            type: CustomFilterType.textSpecified,
            includeInSummary: true
          }
        ],
        type: FilterType.SPECIFIED_TEXT
      }
].filter(filter => !!filter);
